module.exports = __webpack_public_path__ + "img/quote.a188ee20.svg";